export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderSIP@3x.png";